// Core
import React from "react";

// Styles
import "./styles.scss";

const NumberStepper = ({
  index,
  status,
  totalSteps,
  currentSubCategoryIndex,
  hideNumber,
  displayNumber,
}) => {
  const getStatusClass = () => {
    if (status) {
      return "step-completed";
    } else if (index === currentSubCategoryIndex) {
      return "step-inprogress";
    } else {
      return "step-pending";
    }
  };

  const getConnectorColorClass = () => {
    return status ? "connector-completed" : "connector-pending";
  };

  return (
    <div className="numStep-container">
      <div className={`step-number ${getStatusClass()}`}>{hideNumber ? "" : displayNumber}</div>
      {/* Connector Line */}
      {index < totalSteps - 1 && (
        <div className={`step-connector ${getConnectorColorClass()}`}></div>
      )}
    </div>
  );
};

export default NumberStepper;
